export enum ExtendedPropertyType {
    scenario = 'scenario',
    portfolio = 'portfolio',
    portfolioEntity = 'portfolioEntity',
    scenarioManager = 'scenarioManager',
}
